import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import ArticleList from '../components/ArticleList';

import PageLayout from '../components/PageLayout';
import { getArticlesByTag } from '../api';
import PageHeader from '../components/ui/PageHeader';
import PageMain from '../components/ui/PageMain';
import PageBody from '../components/ui/PageBody';

function ArticlesByTag() {
  const { t } = useTranslation();
  const { tagName } = useParams();

  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    let cancelled = false;

    async function loadArticles() {
      try {
        setLoading(true);
        setError('');

        const data = await getArticlesByTag(
          decodeURIComponent(tagName),
        );

        if (!cancelled) {
          setArticles(
            Array.isArray(data) ? data : [],
          );
        }
      } catch (err) {
        console.error(
          'Failed to load articles by tag:',
          err,
        );

        if (!cancelled) {
          setError(
            err?.message ||
              'Failed to load articles',
          );
        }
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    }

    loadArticles();

    return () => {
      cancelled = true;
    };
  }, [tagName]);

  return (
    <PageLayout
      showSearch
      showAiSearch
    >
      <PageMain>

        <PageHeader
          title={`#${decodeURIComponent(tagName)}`}
          condensed
          note={!loading && !error && articles.length === 0 ? t('common.emptyNote') : null}
        />

        {loading && (
          <PageBody>
            <p className="page-message">{t('articlesPage.loading')}</p>
          </PageBody>
        )}

        {error && (
          <PageBody>
            <div
              className="login-message login-message-error"
              role="alert"
            >
              {error}
            </div>
          </PageBody>
        )}

        {!loading &&
          !error &&
          articles.length > 0 && (
            <ArticleList
              articles={articles}
              showTags
            />
          )}

      </PageMain>
    </PageLayout>
  );
}

export default ArticlesByTag;